import type { LngLatArr, MapBounds, MapPOI } from 'shared/map/interfaces';
import type { MapOffer } from '@/interfaces';

export const DEFAULT_BOUNDS: MapBounds = {
    sw: [-10, 30], // Southwest: Atlantic/North Africa
    ne: [40, 60], // Northeast: Eastern Europe/Scandinavia
};

/**
 * Convert offers to MapPOI format for display on the map.
 * Only includes offers with valid coordinates.
 */
export const offersToMapPois = (offers: MapOffer[]): MapPOI[] => {
    const pois: MapPOI[] = [];
    for (const offer of offers) {
        if (offer.latitude != null && offer.longitude != null) {
            pois.push({
                id: offer.offerId,
                name: offer.hotelName,
                coordinates: [offer.longitude, offer.latitude] as LngLatArr,
                price: offer.pricePerPerson,
            });
        }
    }
    return pois;
};

/**
 * Parse map bounds from URL query parameters.
 * Format: minLat,minLon,maxLat,maxLon (same as API bbox format)
 */
export const parseBoundsFromQuery = (query: Record<string, string | string[] | undefined>): MapBounds | null => {
    const bbox = query.bbox;
    if (typeof bbox === 'string') {
        const parts = bbox.split(',').map(Number);
        if (parts.length === 4 && parts.every((n) => !Number.isNaN(n))) {
            // Format: minLat, minLon, maxLat, maxLon
            const [minLat, minLon, maxLat, maxLon] = parts;
            return {
                sw: [minLon, minLat], // [lng, lat]
                ne: [maxLon, maxLat], // [lng, lat]
            };
        }
    }
    return null;
};
